exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer-style[data-v-70f043cb]{font-size:42pt;text-align:center;padding:0;margin:0;line-height:.9em;font-weight:700}.milliseconds[data-v-70f043cb]{font-size:22pt}", ""]);

// exports
